import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../../common/constants';
import utils from '../../../common/utils';

export default class AetTopicEditService extends BaseService {
  constructor() {
    super(constants.UPDATE_AET_TOPIC_DATA, 'AetTopicEditStatus');
    this.fetchPayload = null;
  }

  handleEvent(eventName, event) {
    const { payload, headers } = utils.buildRequestPartsFromPayload(event);
    // eslint-disable-next-line camelcase
    const { feedbacks, rawResponse, topic_id, topics, ...restPayload } = payload;

    // Validate topic_id is present
    // eslint-disable-next-line camelcase
    if (!topic_id) {
      throw new Error('topic_id is required for updating AET Topic');
    }

    // Get tenantId from payload or headers
    const tenantId = payload.tenantId || headers[constants.BERLIN_TENANT_ID_HEADER];
    const { bookId, pageId } = restPayload;

    // Extract the updated topic data from topics array
    // Find the topic with matching topic_id
    // eslint-disable-next-line camelcase
    const updatedTopic = topics?.find((topic) => topic.topic_id === topic_id);
    const topicName = updatedTopic?.topic || '';
    const shortTopic = updatedTopic?.short_topic || '';
    const injectionAfterBlockId = updatedTopic?.injection_after_block_id;
    const evidenceQuotes = updatedTopic?.evidence_quotes;

    // Store fetch payload for refetching after successful update
    this.fetchPayload = {
      bookId,
      pageId,
      tenantId
    };

    // Structure the payload as required by the API
    const properties = {
      topic: topicName,
      short_topic: shortTopic
    };

    // Include injection_after_block_id if it exists
    if (injectionAfterBlockId !== undefined && injectionAfterBlockId !== null) {
      properties.injection_after_block_id = injectionAfterBlockId;
    }

    // Include evidence_quotes (with editable block_id) if present
    if (evidenceQuotes !== undefined && evidenceQuotes !== null) {
      properties.evidence_quotes = evidenceQuotes;
    }

    const dataToSend = {
      criteria: {
        bookId,
        pageId
      },
      properties
    };

    // Use topic_id in the URL path
    // eslint-disable-next-line camelcase
    return this.getClient('aiadminv2').patch(`/cm/topic-aet/topic/${topic_id}`, dataToSend, { headers });
  }

  handleResponse(response) {
    const { data } = response;
    if (data.status === 'success') {
      const notification = {
        open: true,
        type: 'success',
        message: 'AET Topic Updated successfully'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
      Framework.getStoreRegistry().getStore('aetTopicUtility').setUpdateAetTopicResponse(response.data);

      // Refetch the updated data to show in UI
      if (this.fetchPayload) {
        Framework.getStoreRegistry().getStore('aetTopicUtility').fetchAetTopic(this.fetchPayload);
      }
    }
  }

  handleError(error) {
    // eslint-disable-line class-methods-use-this
    const { response } = error;
    if (response) {
      const { status, data } = response;
      if (status === 401) {
        utils.redirectToLogin();
      }
      if (status === 500 && data && data.error) {
        const notification = {
          open: true,
          message: data.error.message,
          type: 'error'
        };
        Framework.getStoreRegistry().getStore('notificationState').set(notification);
      }
    } else if (error.message === 'timeout of 60000ms exceeded') {
      const notification = {
        open: true,
        message: error.message,
        type: 'error'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
    }
  }
}
